<template>
    <el-dialog
            title="添加字典"
            class="selfModal"
            :close-on-click-modal="false"
            :visible="addData.state"
            width="480px"
            @close="closeModal()"
            :modal="false"
    >
        <div style="padding-right: 20px">
            <el-form :model="formValidate" :rules="ruleValidate" ref="ruleForm" label-width="60px"
                     class="demo-ruleForm">
                <el-form-item label="类型" prop="type">
                    <el-input v-model="formValidate.type"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input v-model="formValidate.description"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input v-model="formValidate.remarks"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submitForm('ruleForm')" :disabled="subDisabled">确 认</el-button>
            <el-button @click="resetForm('ruleForm')">重 置</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {addObj} from '@/api/admin/dict'

    export default {
        props: {
            addData: {
                type: Object,
                required: true
            }
        },
        components: {},
        data() {
            return {
                subDisabled: false,
                formValidate: {
                    id: null,
                    value: '',
                    type: '',
                    label: '',
                    description: '',
                    remarks: '',
                    sort: 0,
                    sysFlag: 0
                }, // 表单数据绑定
                ruleValidate: {
                    type: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 80, message: '长度在 1 到 80 个字符', trigger: 'blur'}
                    ],
                    description: [
                        {required: true, message: '该项必须填写', trigger: 'blur'},
                        {min: 1, max: 80, message: '长度在 1 到 80 个字符', trigger: 'blur'}
                    ],
                    remarks: [
                        {required: false, message: '', trigger: 'blur'},
                        {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
                    ]
                }, // 表单验证
            };
        },
        computed: {},
        methods: {

            closeModal() {
                this.$emit("closeAdd", {state: false});
                this.addData.state = false;
                setTimeout(() => {
                    this.$refs['ruleForm'].resetFields();
                    this.formValidate.remarks = ''
                }, 200)
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.subDisabled = true;
                        addObj(this.formValidate).then(res => {
                            if (res.data.code == 0) {
                                this.subDisabled = false;
                                this.$refs[formName].resetFields();
                                this.closeModal()
                            } else {
                                this.subDisabled = false;
                                this.$alert(res.data.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning'
                                });
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.formValidate = {
                    id: null,
                    value: '',
                    type: '',
                    label: '',
                    description: '',
                    remarks: '',
                    sort: 0,
                    sysFlag: 0
                };
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>

</style>